let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hH8zC")).then(() => parcelRequire('3wKm1'));